'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _RenderIf = require('../../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable no-script-url */


var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem(props) {
    _classCallCheck(this, MenuItem);

    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));

    _this.itemRef = _react2.default.createRef();
    _this.handleHover = _this.handleHover.bind(_this);
    return _this;
  }

  _createClass(MenuItem, [{
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var isActive = this.props.isActive;
      return (0, _classnames2.default)('rainbow-lookup_menu-item', {
        'rainbow-lookup_menu-item--active': isActive
      });
    }
  }, {
    key: 'handleHover',
    value: function handleHover() {
      var _props = this.props,
          onHover = _props.onHover,
          index = _props.index;
      onHover(index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          label = _props2.label,
          description = _props2.description,
          icon = _props2.icon,
          onClick = _props2.onClick;
      return _react2.default.createElement('li', {
        className: this.getContainerClassNames(),
        role: 'presentation',
        onMouseDown: onClick,
        onMouseEnter: this.handleHover
      }, _react2.default.createElement('a', {
        tabIndex: -1,
        className: 'rainbow-lookup_menu-item-link',
        href: 'javascript:void(0);',
        role: 'menuitem',
        ref: this.itemRef
      }, _react2.default.createElement(_RenderIf2.default, {
        isTrue: !!icon
      }, _react2.default.createElement('span', {
        className: 'rainbow-lookup_menu-item_icon-container'
      }, icon)), _react2.default.createElement('span', {
        className: 'rainbow-lookup_menu-item_label-container'
      }, label, _react2.default.createElement(_RenderIf2.default, {
        isTrue: !!description
      }, _react2.default.createElement('span', {
        className: 'rainbow-lookup_menu-item_description'
      }, description)))));
    }
  }]);

  return MenuItem;
}(_react.Component);

exports.default = MenuItem;
MenuItem.propTypes = {
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  description: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  isActive: _propTypes2.default.bool,
  onHover: _propTypes2.default.func,
  index: _propTypes2.default.number
};
MenuItem.defaultProps = {
  label: undefined,
  description: undefined,
  icon: undefined,
  onClick: function onClick() {},
  isActive: false,
  onHover: function onHover() {},
  index: undefined
};